import React from "react";
import Modal from "react-bootstrap/Modal";
import Image from 'react-bootstrap/Image'
import Container from "react-bootstrap/Container";
import Carousel from "react-bootstrap/Carousel";

const HelpModal = (props) => {


    const helpVideo = 'Image_viewing_walkthrough.mp4';
    const welcomeVideo = 'GHI_V061.mp4';

    const hideModal = (evt) => {
        props.closefunc(evt);
    };

    // const imageURL =  window.isMobile ? process.env.PUBLIC_URL + "/images/MobilePortrait_QuestionMarkHelpCard.png" : process.env.PUBLIC_URL + "/images/Desktop_QuestionMarkHelpCard.png";
    const navigationImage = window.isMobile ? process.env.PUBLIC_URL + "/images/mobile_navigation.png" : process.env.PUBLIC_URL + "/images/desktop_navigation.png";
    const menuIcons = process.env.PUBLIC_URL + "/images/menu_icons.png";
    const chromeFirefoxImg = process.env.PUBLIC_URL + "/images/chrome_firefox.png";

    const imageStyle = window.isMobile ? {maxWidth: "90%"} : {maxWidth: "60%"};
    const chromeFirefoxStyle = window.isMobile ? {maxWidth: "20%"} : {maxWidth: "10%"};

    // const mobileTroubleshooting = () => {
    //     if(window.isMobile) {
    //         return (
    //             <Carousel.Item>
    //                 <Container className="text-center">
    //                     <div className="help-divs">
    //                         <div className="help-troubleshooting-ul">
    //                             <h5 className="text-center">Troubleshooting</h5>
    //                             <ul className="text-justify">
    //                                 <li>If this experience begins to lag on your device try reducing the size of your browser window or downscaling your screen resolution.</li>
    //                                 <li>Please ensure only one video screen is playing at once as multiple screens playing can produce lag in the experience.</li>
    //
    //                                 <li>Please ensure only one video screen is playing at once as multiple screens playing can produce lag in the experience.</li>
    //                                 <li>Please ensure only one video screen is playing at once as multiple screens playing can produce lag in the experience.</li>
    //                             </ul>
    //                         </div>
    //                     </div>
    //                 </Container>
    //             </Carousel.Item>
    //             )
    //     }
    //     return null;
    // }

    return (
            <Modal dialogClassName={"primaryModal modal-dialog modal-dialog-centered modal-dialog-scrollable"} show={props.showHelp}
                   onHide={hideModal} size={props.modelType}
                   className={"help-dialog"}
                   scrollable={"true"}
                // className="v21-modal-color"
            >
                {/*className="v21-modal-color"*/}
                <Modal.Header closeButton style={{border:'none'}}  >
                </Modal.Header>
                <Modal.Body>
                    <Carousel interval={null} indicators={false}>

                            <Carousel.Item>
                                <div>
                                    <h5 className="text-center">Introduction with Professor Lucie Armitt</h5>
                                    <video playsInline width="100%" controls>
                                        <source src={process.env.PUBLIC_URL + `/videos/${welcomeVideo}`} type="video/mp4"/>
                                        <source src={process.env.PUBLIC_URL + `/videos/${welcomeVideo}`} type="video/ogg"/>
                                        Your browser does not support HTML video.
                                    </video>
                                </div>
                            </Carousel.Item>


                        <Carousel.Item>
                            <Container className="text-center">
                                <div className="help-divs">
                                    {window.isMobile ?
                                        <h5>Navigation Tips</h5>
                                        :
                                        <h4>Navigation Tips</h4>
                                    }

                                    <div className="text-center">
                                            <p className="help-image-paragraph">
                                                <Image className="img-responsive"
                                                       // style={{maxWidth: "60%"}}
                                                       style={imageStyle}
                                                       src={navigationImage}
                                                       alt={"Entry Image"} fluid/>
                                            </p>
                                    </div>
                                </div>

                            </Container>
                        </Carousel.Item>

                        {/*{window.isMobile ? null*/}
                        {/*    :*/}
                        {/*    <Carousel.Item>*/}
                        {/*        <div>*/}
                        {/*            <h5 className="text-center">'How To' Video</h5>*/}
                        {/*            <video playsInline width="100%" controls>*/}
                        {/*                <source src={process.env.PUBLIC_URL + `/videos/help/${helpVideo}`} type="video/mp4"/>*/}
                        {/*                <source src={process.env.PUBLIC_URL + `/videos/help/${helpVideo}`} type="video/ogg"/>*/}
                        {/*                Your browser does not support HTML video.*/}
                        {/*            </video>*/}
                        {/*        </div>*/}
                        {/*    </Carousel.Item>*/}
                        {/*}*/}

                        {!window.isMobile ?
                        <Carousel.Item>
                            <Container className="text-center">
                                {/*<div className="help-divs">*/}
                                    <h4>Menu Icons</h4>
                                    <p className="text-center help-image-paragraph">
                                        <Image className="img-responsive"
                                               style={imageStyle}
                                               src={menuIcons}
                                               alt={"Entry Image"} fluid/>
                                    </p>
                            </Container>
                        </Carousel.Item>
                            : null
                        }

                        <Carousel.Item>
                            <Container className="text-center">
                                <div className="help-divs">
                                    {/*<div className="help-troubleshooting">*/}
                                    <div className="help-troubleshooting-ul">
                                            <div>
                                                {window.isMobile ?
                                                    <h5 className="text-center">Troubleshooting</h5>
                                                :
                                                    <h4 className="text-center">Troubleshooting</h4>
                                                }

                                                <ul className="text-justify">
                                                    <li>If this experience starts lagging, reduce the size of your browser or downscale your screen resolution.</li>
                                                    <li>For better performance play one video at a time.</li>
                                                    <li>
                                                        We recommend using Google Chrome or Firefox browsers
                                                        <Image className="img-responsive"
                                                               style={chromeFirefoxStyle}
                                                               src={chromeFirefoxImg}
                                                               alt={"Entry Image"} fluid/>
                                                        <span>.</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        {/*}*/}
                                    </div>
                                </div>
                            </Container>
                        </Carousel.Item>
                        {/*{mobileTroubleshooting()}*/}
                    </Carousel>
                </Modal.Body>
            </Modal>
    );
};

export default HelpModal;